import { render } from "./ModalOrderCutOffConfirm.vue?vue&type=template&id=055edffe&scoped=true"
import script from "./ModalOrderCutOffConfirm.vue?vue&type=script&lang=js"
export * from "./ModalOrderCutOffConfirm.vue?vue&type=script&lang=js"

import "./ModalOrderCutOffConfirm.vue?vue&type=style&index=0&id=055edffe&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055edffe"]])

export default __exports__